
import { defineComponent, onMounted, PropType, Ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons-vue";
import { BreadcrumbType, RoutesDataItem } from "@/utils/routes";
import BreadCrumbs from "@/components/BreadCrumbs/index.vue";
import SelectLang from "@/components/SelectLang/index.vue";
import ALink from "@/components/ALink/index.vue";
import RightTopMessage from "./RightTopMessage.vue";
import RightTopUser from "./RightTopUser.vue";
import RightTabNav from "./RightTabNav.vue";
import useTopMenuWidth from "../composables/useTopMenuWidth";

interface RightTopSetupData {
  t: (key: string | number) => string;
  topMenuCon: Ref;
  topMenuWidth: Ref;
}

export default defineComponent({
  name: "RightTop",
  components: {
    ALink,
    BreadCrumbs,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    EnvironmentOutlined,
    RightTopMessage,
    RightTopUser,
    SelectLang,
    RightTabNav,
  },
  props: {
    // 菜单图标
    collapsed: {
      type: Boolean,
      default: false,
    },
    tabNavEnable: {
      type: Boolean,
      default: true,
    },
    topNavEnable: {
      type: Boolean,
      default: true,
    },
    belongTopMenu: {
      type: String,
      default: "",
    },
    toggleCollapsed: {
      type: Function as PropType<() => void>,
    },
    breadCrumbs: {
      type: Array as PropType<BreadcrumbType[]>,
      default: () => {
        return [];
      },
    },
    menuData: {
      type: Array as PropType<RoutesDataItem[]>,
      default: () => {
        return [];
      },
    },
    routeItem: {
      type: Object as PropType<RoutesDataItem>,
      required: true,
    },
  },
  setup(props): RightTopSetupData {
    const { t } = useI18n();
    const { topNavEnable } = toRefs(props);

    const { topMenuCon, topMenuWidth } = useTopMenuWidth(topNavEnable);

    return {
      t,
      topMenuCon,
      topMenuWidth,
    };
  },
});
